import AuthService from "./AuthService";

/**
 * @namespace com.ang.portal.service
 */

export interface AuditLogEntry {
	id: number;
	actorUserId: number | null;
	actorEmail: string | null;
	action: string;
	entityType: string;
	entityId: string | null;
	beforeData: Record<string, unknown> | null;
	afterData: Record<string, unknown> | null;
	ipAddress: string | null;
	userAgent: string | null;
	createdAt: string;
}

export interface AuditLogQuery {
	action?: string;
	entityType?: string;
	entityId?: string;
	actorUserId?: number;
	actorEmail?: string;
	fromDate?: string;
	toDate?: string;
	limit?: number;
	offset?: number;
}

const AuditLogService = {
	async find(query: AuditLogQuery = {}): Promise<AuditLogEntry[]> {
		const params = new URLSearchParams();
		if (query.action) params.set("action", query.action);
		if (query.entityType) params.set("entityType", query.entityType);
		if (query.entityId) params.set("entityId", query.entityId);
		if (typeof query.actorUserId === "number") {
			params.set("actorUserId", String(query.actorUserId));
		}
		if (query.actorEmail) params.set("actorEmail", query.actorEmail);
		if (query.fromDate) params.set("fromDate", query.fromDate);
		if (query.toDate) params.set("toDate", query.toDate);
		if (typeof query.limit === "number")
			params.set("limit", String(query.limit));
		if (typeof query.offset === "number")
			params.set("offset", String(query.offset));

		const qs = params.toString();
		const url = qs ? `/api/audit-logs?${qs}` : "/api/audit-logs";

		const response = await AuthService.authenticatedFetch(url);
		if (!response.ok) {
			throw new Error("Failed to fetch audit logs");
		}
		return response.json() as Promise<AuditLogEntry[]>;
	},
};

export default AuditLogService;
